// extracted by mini-css-extract-plugin
module.exports = {"tx_green":"Footer_tx_green__worQR","contentFooter":"Footer_contentFooter__2zwKQ"};